import styled from 'styled-components';

const InputDisabled = styled.div`
    box-shadow: none;
    border: 0;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;

    color: #666666;
    -webkit-text-fill-color: #666666;
    opacity: 1; /* required on iOS */

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default InputDisabled;
